import { createSlice } from '@reduxjs/toolkit';
import { initialState } from 'state/redux/slices/app/appState';
import { reducers } from 'state/redux/slices/app/appReducers';

export const appSlice = createSlice({
    name: 'app',
    reducers,
    initialState,
});
